import React from 'react'

const NewLineToBr = ({ value }) => {
  if (!value) return null

  const text = value.split('\n').reduce((acc, item, idx) => {
    if (item.trim() !== '') {
      acc.push(
        <React.Fragment key={idx}>
          <div dangerouslySetInnerHTML={{ __html: item }} />
          <br />
        </React.Fragment>
      )
    }
    return acc
  }, [])

  return <>{text}</>
}

export default NewLineToBr
